<template>
    <div class="aside" :class="{'close': !asideCollapseButton}" v-if="userInfo">
        <div class="aside-open__list mobile-view">
            <div class="aside-open__router-link">使用者：{{userName}}</div>
        </div>
        <el-collapse class="aside-open__collapse" v-model="meauCollapse">
            <el-collapse-item class="aside-open__collapse-item" name="admin">
                <span slot="title">管理專區</span>
                <router-link class="aside-open__router-link" :to="`${root}/adminArea/summary`">
                    <i class="aside-open__router-link-icon el-icon-s-marketing"></i>
                    <span class="aside-open__router-link-text">摘要總覽</span>
                </router-link>
                <router-link class="aside-open__router-link" :to="`${root}/adminArea/regList`">
                    <i class="aside-open__router-link-icon el-icon-s-tools"></i>
                    <span class="aside-open__router-link-text">場站搜尋</span>
                </router-link>
            </el-collapse-item>
            <el-collapse-item class="aside-open__collapse-item" name="report">
                <span slot="title">回報場站</span>
                <router-link class="aside-open__router-link" :to="`${root}/report/ntpReport`">
                    <i class="aside-open__router-link-icon el-icon-s-promotion"></i>
                    <span class="aside-open__router-link-text">新北報表</span>
                </router-link>
            </el-collapse-item>
        </el-collapse>
        <div class="aside-open__list mobile-view">
            <router-link class="aside-open__router-link" :to="`${root}/resetNickname`">更改暱稱</router-link>
        </div>
        <div class="aside-open__list mobile-view">
            <router-link class="aside-open__router-link" :to="`${root}/resetPassword`">更改密碼</router-link>
        </div>
        <div class="aside-open__list mobile-view">
            <button type="button" class="aside-open__router-link" @click="toLogout()">登出</button>
        </div>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
export default {
    name: "pacaAside",
    data(){
        return{
            userInfo: this.$store.state.userInfo,
            root: process.env.VUE_APP_PACACLOUND_ROOT,
            beforeCloseAsideCollapse: ['service', 'partner', 'report', 'admin'],
        }
    },
    methods: {
        changeLocale(locale){
            this.$message.success({
                duraction: 2500,
                showClose: true,
                message: this.$t("footer.changeLanguage")
            })
            this.$i18n.locale = locale;
        },
        async toLogout(){
            await api.postLogout();
        },
    },
    computed:{
        meauCollapse: {
            set(openingItem){
                this.$store.commit({
                    type: "setMeauCollapse",
                    open: openingItem
                })
            },
            get(){
                return this.$store.state.meauCollapse
            }
        },
        asideCollapseButton(){
            return this.$store.state.asideCollapseButton
        },
        userName(){
            return this.$store.state.userInfo ? this.$store.state.userInfo.nickname : ''
        }
    },
    watch: {
        asideCollapseButton(val){
            if(window.innerWidth > 992){
                if(val == false){
                    this.beforeCloseAsideCollapse = this.meauCollapse;
                    this.$store.commit({
                        type: "setMeauCollapse",
                        open: ['service', 'partner', 'report', 'admin'],
                    })
                }else{
                    this.$store.commit({
                        type: "setMeauCollapse",
                        open: this.beforeCloseAsideCollapse
                    })
                }
            }
        }
    }
}
</script>